import createGeodesicFeature from '../utils/create_geodesic_geojson';
import * as Constants from '@mapbox/mapbox-gl-draw/src/constants';
import createVertex from '@mapbox/mapbox-gl-draw/src/lib/create_vertex';
import createGeodesicGeojson from '../utils/create_geodesic_geojson';

function patchDrawLineString(DrawLineString) {
  const DrawLineStringPatched = { ...DrawLineString };

  DrawLineStringPatched.toDisplayFeatures = function(state, geojson, display) {


    const draw_get_shape_type_selected = (geojson) => {
      let shapeType = 'None';

      if(geojson) {
        const properties = geojson.properties;
        const type = geojson.geometry.type;

        if(properties.hasOwnProperty('circleRadius') || properties.hasOwnProperty('user_circleRadius')) {
          shapeType = 'Circle';
        } else if(properties.hasOwnProperty('bezierGroup') || properties.hasOwnProperty('user_bezierGroup')) {
          shapeType = 'BezierCurve';
        } else {
          shapeType = type;
        }
      }

      return shapeType;
    }

    const displayGeodesic = (geojson) => {
      if(geojson.properties.user_circleRadius) {
        const geodesicGeojson = createGeodesicGeojson(geojson, { ctx: this._ctx });
        geodesicGeojson.forEach(display);
      } else {
        display(geojson);
      }
    };



    //DrawLineString.toDisplayFeatures.call(this, state, geojson, displayGeodesic);


    const isActiveLine = geojson.properties.id === state.line.id;
    geojson.properties.active = (isActiveLine) ? Constants.activeStates.ACTIVE : Constants.activeStates.INACTIVE;
    if (!isActiveLine) return displayGeodesic(geojson);
    // Only render the line if it has at least one real coordinate
    if (geojson.geometry.coordinates.length < 2) return;
    geojson.properties.meta = Constants.meta.FEATURE;
    display(createVertex(
      state.line.id,
      geojson.geometry.coordinates[state.direction === 'forward' ? geojson.geometry.coordinates.length - 2 : 1],
      `${state.direction === 'forward' ? geojson.geometry.coordinates.length - 2 : 1}`,
      false
    ));

    display(geojson);
  };

  return DrawLineStringPatched;
}

export default patchDrawLineString;
